import { render, staticRenderFns } from "./AppTerms.vue?vue&type=template&id=c79d4560&scoped=true"
import script from "./AppTerms.vue?vue&type=script&lang=ts"
export * from "./AppTerms.vue?vue&type=script&lang=ts"
import style0 from "./AppTerms.vue?vue&type=style&index=0&id=c79d4560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79d4560",
  null
  
)

export default component.exports